"use client";

import { Play } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CaseStudiesHero() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1858" id="case-studies-hero" className="relative overflow-hidden bg-background text-foreground py-32 md:py-44">
      {}
      <svg aria-hidden="true" className="pointer-events-none absolute left-0 top-0 h-full w-24 md:w-40 opacity-40" viewBox="0 0 160 800" fill="none" preserveAspectRatio="none">
        <path d="M40 0 C 70 120, 20 220, 60 340 S 100 560, 50 700 L 50 800" stroke="currentColor" strokeWidth="1" className="text-primary/40" />
      </svg>

      {}
      <svg aria-hidden="true" className="pointer-events-none absolute -right-24 top-16 hidden md:block h-[720px] w-[640px] opacity-60" viewBox="0 0 640 720" fill="none">
        <path d="M520 90 C 600 160, 640 280, 600 400 C 560 540, 440 640, 300 660 C 180 680, 60 600, 40 460 C 20 320, 80 180, 200 110 C 320 40, 440 30, 520 90 Z" fill="currentColor" className="text-accent/30" />
      </svg>

      <div className="relative mx-auto max-w-[1320px] px-4 sm:px-6 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {}
          <div ref={leftRef} className="lg:col-span-8 transition-all duration-[720ms] ease-out" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(16px)"
        }}>
            {}
            <div className="flex items-center gap-3 mb-10">
              <span className="font-mono text-[0.6875rem] uppercase tracking-[0.08em] text-muted-foreground">
                STRATEGIC WELLBEING
              </span>
              <span className="font-mono text-[0.6875rem] uppercase tracking-[0.08em] text-muted-foreground">
                · §01 — CASE STUDIES
              </span>
            </div>

            {}
            <h1 className="font-default font-bold text-secondary leading-[1.02] tracking-tight mb-10" style={{
            fontSize: "clamp(2.75rem, 6.4vw, 5.75rem)"
          }}>
              Results from real organisations.
            </h1>

            {}
            <p className="font-default text-muted-foreground max-w-[480px] mb-12 leading-[1.65]" style={{
            fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)"
          }}>
              These are not projections or estimates. They are results from actual engagements with Feel Good Works.
            </p>

            {}
            <div className="flex flex-wrap items-center gap-4 mb-14">
              <Button asChild className="h-[52px] rounded-lg px-7 bg-primary text-primary-foreground hover:bg-primary/90 font-semibold tracking-wide transition-all duration-220 hover:-translate-y-[1.5px] shadow-md">
                <Link to="/FeelGoodWorksServicesPage">Our Services</Link>
              </Button>
              <Button asChild variant="outline" className="h-[52px] rounded-lg px-7 bg-transparent border border-border text-secondary hover:bg-accent hover:border-primary hover:text-secondary font-semibold tracking-wide transition-all duration-220 shadow-sm">
                <Link to="/WhatIsWellbeingPage">
                  <Play className="size-3.5" strokeWidth={2} />
                  The Methodology
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className="lg:col-span-4 relative transition-all duration-[720ms] ease-out" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateY(0)" : "translateY(16px)",
          transitionDelay: "120ms"
        }}>
            {}
            <svg aria-hidden="true" className="pointer-events-none absolute -inset-8 -z-0" viewBox="0 0 400 500" fill="none" preserveAspectRatio="none">
              <path d="M340 60 C 400 130, 410 260, 360 360 C 310 460, 180 480, 90 420 C 0 360, -10 220, 50 130 C 110 40, 280 -10, 340 60 Z" fill="currentColor" className="text-accent/40" />
            </svg>

            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg shadow-xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645819/img/corporate_wellbeing_workshop_collaboration.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645819/img/corporate_wellbeing_workshop_collaboration.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645819/img/corporate_wellbeing_workshop_collaboration.webp-wvc-sizes" alt="Professional team collaborating in a bright, modern office space focused on wellbeing" loading="lazy" decoding="async" className="h-full w-full object-cover" />
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-border" />
    </section>;
}